import { getView, requireAuth } from '@/lib/utils';
import { AssetsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/assets',
  component: getView('pages/PageAssets'),
  name: 'assets',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Assets',
    leftMenu: Left.AssetsList,
    roles: ['operator'],
    information: AssetsPage,
    showBottomMenu: true,
  },
};
